<template>
  <!-- 建设阶段 -->
    <div class="bid-box">
        <table class="layui-table">
            <colgroup>
                <col width="100">
                <col width="200">
                <col width="200">
                <col>
            </colgroup>
            <thead>
                <tr>
                    <th>序号</th>
                    <th>阶段</th>
                    <th>工程节点</th>
                    <th>内容</th>
                </tr> 
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td rowspan="19">建设阶段</td>
                    <td>设计单位</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;">
                            <p style="margin:0 1vw;">名称：{{final.designUnit||'--'}}</p>
                            <p style="margin:0 1vw;">负责人：{{final.designName||'--'}}</p>
                            <p style="margin:0 1vw;">电话：{{final.designPhone||'--'}}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>勘察单位</td>
                    <td style="text-align: left;display:flex;">
                        <p style="margin:0 1vw;">名称：{{final.reconnaissanceUnit||'--'}}</p>
                        <p style="margin:0 1vw;">负责人：{{final.reconnaissanceName||'--'}}</p>
                        <p style="margin:0 1vw;">电话：{{final.reconnaissancePhone||'--'}}</p>
                    </td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>施工总包单位</td>
                    <td>
                        <div style="width:100%;display:flex;">
                            <p style="margin:0 1vw;">名称：{{final.auditorDeptName||'--'}}</p>
                            <p style="margin:0 1vw;">负责人：{{final.auditorHeadName||'--'}}</p>
                            <p style="margin:0 1vw;">电话：{{final.auditorHeadPhone||'--'}}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>监理单位</td>
                    <td>
                        <div style="width:100%;display:flex;">
                            <p style="margin:0 1vw;">名称：{{final.jlAuditorDeptName||'--'}}</p>
                            <p style="margin:0 1vw;">负责人：{{final.jlAuditorHeadName||'--'}}</p>
                            <p style="margin:0 1vw;">电话：{{final.jlAuditorHeadPhone||'--'}}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>检测单位</td>
                    <td>
                        <div style="width:100%;display:flex;">
                            <p style="margin:0 1vw;">名称：{{final.jcAuditorDeptName||'--'}}</p>
                            <p style="margin:0 1vw;">负责人：{{final.jcAuditorHeadName||'--'}}</p>
                            <p style="margin:0 1vw;">电话：{{final.jcAuditorHeadPhone||'--'}}</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>工程障碍</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in final.deliver.list" :key="index">
                                <span style="margin-right:1vw;">{{item.startTime}}</span>
                                <span style="margin-right:1vw;">{{item.start}}</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" @click="showFile(val)">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="final.deliver.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="final.deliver.flag">无</el-checkbox>
                        <div v-if="!final.deliver.flag">
                            <div v-for="(item,index) in final.deliver.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex='-1'" @mouseenter="delIndex=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">    
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">   
                                </el-date-picker>
                                <el-input v-if="edit" v-model="item.start" placeholder="请输入内容" style="width:10vw;" @blur="setFirstTotal"></el-input>
                                <el-input v-else disabled v-model="item.start" placeholder="请输入内容" style="width:10vw;" @blur="setFirstTotal"></el-input>
                                <span style="margin-right:2vw;padding-left:5px;"></span>      
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess"
                                    :on-remove="handleDel"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toFirstAccount" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex==index" class="el-icon-delete ctl" @click="delFirstAccount(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>项目许可证</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" v-for="(item,index) in final.buildPermit.list[0].files" :key="index" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span class="" style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="final.buildPermit.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="final.buildPermit.flag">无</el-checkbox>
                        <div v-if="!final.buildPermit.flag">
                            <div v-for="(item,index) in final.buildPermit.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                                <el-upload
                                    class="upload-demo"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess2"
                                    :on-remove="handleDel2"
                                    :on-preview="showFile"
                                    :file-list="final.buildPermit.list">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>开工时间</td>
                    <td style="text-align: left;">
                        <p>{{final.startDate}}</p>
                    </td>
                </tr>
                <tr>
                    <td>9</td>
                    <td>开工报告</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" v-for="(item,index) in final.startBook.list[0].files" :key="index" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="final.startBook.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="final.startBook.flag">无</el-checkbox>
                        <div v-if="!final.startBook.flag">
                            <div v-for="(item,index) in final.startBook.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                                <el-upload
                                    class="upload-demo"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess3"
                                    :on-remove="handleDel3"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>总进度计划</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" v-for="(item,index) in final.schedulePlan.list[0].files" :key="index" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <div v-if="!final.schedulePlan.flag">
                        <div v-for="(item,index) in final.schedulePlan.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHead"
                                :data="{type:232}"
                                :objectBind='item.index'
                                :on-success="handleSuccess5"
                                :on-remove="handleDel5"
                                :on-preview="showFile"
                                :file-list="item.files">
                                <el-button size="small" v-if="edit" type="primary">点击上传</el-button>
                            </el-upload>
                        </div>
                    </div> -->
                    </td>
                </tr>
                <tr>
                    <td>11</td>
                    <td>项目进度</td>
                    <td>
                        
                    </td>
                </tr>
                <tr>
                    <td>12</td>
                    <td>实际进度</td>
                    <td>
                        
                    </td>
                </tr>
                <tr>
                    <td>13</td>
                    <td>标准化、示范工地验收情况</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" v-for="(item,index) in final.inspection.list[0].files" :key="index" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <el-checkbox  v-if="edit" v-model="final.inspection.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="final.inspection.flag">无</el-checkbox>
                        <div v-if="!final.inspection.flag">
                            <div v-for="(item,index) in final.inspection.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                            <el-upload
                                    class="upload-demo"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess7"
                                    :on-remove="handleDel7"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>14</td>
                    <td>合约方联系函件</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" v-for="(item,index) in final.contactLetter.list[0].files" :key="index" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <el-checkbox  v-if="edit" v-model="final.contactLetter.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="final.contactLetter.flag">无</el-checkbox>
                        <div v-if="!final.contactLetter.flag">
                            <div v-for="(item,index) in final.contactLetter.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                            <el-upload
                                    class="upload-demo"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess9"
                                    :on-remove="handleDel9"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>15</td>
                    <td>违约金处理处罚单</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in final.punish.list" :key="index" @click="showFile(item)">
                                <span v-if="item.startTime" style="margin-right:1vw;">{{item.startTime}}</span>
                                <span v-if="item.money" style="margin-right:1vw;">处罚金额：{{item.money}}万</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="final.punish.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="final.punish.flag">无</el-checkbox>
                        <div v-if="!final.punish.flag">
                            <div v-for="(item,index) in final.punish.list" :key="index" style="display:flex;" @mouseleave="delIndex3='-1'" @mouseenter="delIndex3=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">
                                </el-date-picker>
                                <el-input v-if="edit"  tye="textarea" @input="getMoney1"  v-model="item.money" placeholder="处罚金额" style="margin-right:1vw;"></el-input>
                                <el-input  v-else disabled tye="textarea" @input="getMoney1"  v-model="item.money" placeholder="处罚金额" style="margin-right:1vw;"></el-input>
                                <el-upload
                                    class="upload-demo"
                                    style="width:40%;"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess11"
                                    :on-remove="handleDel11"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" v-if="edit" type="primary" >点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddpunish" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex3==index" class="el-icon-delete ctl" @click="delpunish(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                        <div v-if="final.punish.total" style="text-align: left;margin-left: 18%;height: 3vh;line-height: 4vh;">统计(万元)：{{final.punish.total}}</div>
                    </td>
                </tr>
                <tr>
                    <td>16</td>
                    <td>农民工工资支付审批</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in final.wagePay.list" :key="index" @click="showFile(item)">
                                <span>{{item.startTime}}</span>
                                <span v-if="item.money">工资：{{item.money}}万</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <el-checkbox v-model="final.wagePay.flag">无</el-checkbox>
                        <div v-if="!final.wagePay.flag">
                            <div v-for="(item,index) in final.wagePay.list" :key="index" style="display:flex;" @mouseleave="delIndex4='-1'" @mouseenter="delIndex4=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.startTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="margin-right:20px">
                                </el-date-picker>
                                <el-input v-if="edit" tye="textarea"  @input="getwagePay"  v-model="item.money" placeholder="输入金额" style="margin-right:1vw;"></el-input>
                                <el-input  v-else disabled  tye="textarea"  @input="getwagePay"  v-model="item.money" placeholder="输入金额" style="margin-right:1vw;"></el-input>
                            <el-upload
                                    class="upload-demo"
                                    style="width:40%;"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess12"
                                    :on-remove="handleDel12"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAddwagePay" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex4==index" class="el-icon-delete ctl" @click="delwagePay(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                        <div v-if="final.wagePay.total" style="text-align: left;margin-left: 18%;height: 3vh;line-height: 4vh;">统计(万元)：{{final.wagePay.total}}</div>
                    </td>
                </tr>
                <tr>
                    <td>17</td>
                    <td>房屋测绘报告</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" v-for="(item,index) in final.mapReport.list[0].files" :key="index" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="final.mapReport.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="final.mapReport.flag">无</el-checkbox>
                        <div v-if="!final.mapReport.flag">
                            <div v-for="(item,index) in final.mapReport.list" :key="index" style="display:flex;">
                            <el-upload
                                    class="upload-demo"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess13"
                                    :on-remove="handleDel13"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>18</td>
                    <td>完工时间</td>
                    <td style="text-align: left;">
                        <p>{{final.finishDate}}</p>
                        <!-- <el-date-picker
                            v-if="edit"
                            v-model="final.finishDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker>
                        <el-date-picker
                            v-else disabled
                            v-model="final.finishDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期"
                             style="margin-right:20px">
                        </el-date-picker> -->
                    </td>
                </tr>
                <tr>
                    <td>19</td>
                    <td>合同价</td>
                    <td style="text-align: left;">
                        <p v-if="final.price && final.price!=''">{{final.price}}万元</p>
                    </td>
                </tr>
                <!-- <tr>
                    <td>20</td>
                    <td>其他</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in final.otherFile.list" :key="index" @click="showFile(item)">
                                <span>内容：{{item.name}}</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr> -->
                <tr>
                    <td>20</td>
                    <td rowspan="13">验收阶段</td>
                    <td>综检时间及验收文件</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in accept.compositeAcceptance.list" :key="index" @click="showFile(item)">
                                <span v-if="item.time" style="margin-right:1vw;">日期：{{item.time}}</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <el-checkbox v-if="edit"  v-model="accept.compositeAcceptance.flag">无</el-checkbox>
                        <el-checkbox v-else disabled  v-model="accept.compositeAcceptance.flag">无</el-checkbox>
                        <div v-if="!accept.compositeAcceptance.flag">
                            <div v-for="(item,index) in accept.compositeAcceptance.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex6='-1'" @mouseenter="delIndex6=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess1"
                                    :on-remove="handleDel1"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button v-if="edit"  size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd1" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex6==index" class="el-icon-delete ctl" @click="delList1(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>21</td>
                    <td>雨污水接管验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in accept.rainWater.list" :key="index" @click="showFile(item)">
                                <span v-if="item.time" style="margin-right:1vw;">日期：{{item.time}}</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="accept.rainWater.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="accept.rainWater.flag">无</el-checkbox>
                        <div v-if="!accept.rainWater.flag">
                            <div v-for="(item,index) in accept.rainWater.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex7='-1'" @mouseenter="delIndex7=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess2"
                                    :on-remove="handleDel2"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd2" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex7==index" class="el-icon-delete ctl" @click="delList2(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>22</td>
                    <!-- <td>验收阶段</td> -->
                    <td>人防验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in accept.civilDenfence.list" :key="index" @click="showFile(item)">
                                <span v-if="item.time" style="margin-right:1vw;">日期：{{item.time}}</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <el-checkbox  v-if="edit"  v-model="accept.civilDenfence.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="accept.civilDenfence.flag">无</el-checkbox>
                        <div v-if="!accept.civilDenfence.flag">
                            <div v-for="(item,index) in accept.civilDenfence.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex7='-1'" @mouseenter="delIndex7=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess3"
                                    :on-remove="handleDel3"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button  v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i  v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd3" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i  v-if="edit" v-show="delIndex7==index" class="el-icon-delete ctl" @click="delList3(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>23</td>
                    <!-- <td>验收阶段</td> -->
                    <td>环保验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in accept.environmntProtect.list" :key="index" @click="showFile(item)">
                                <span v-if="item.time" style="margin-right:1vw;">日期：{{item.time}}</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <el-checkbox  v-if="edit" v-model="accept.environmntProtect.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="accept.environmntProtect.flag">无</el-checkbox>
                        <div v-if="!accept.environmntProtect.flag">
                            <div v-for="(item,index) in accept.environmntProtect.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex8='-1'" @mouseenter="delIndex8=index">
                                <el-date-picker
                                    v-if="edit" 
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess4"
                                    :on-remove="handleDel4"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button v-if="edit"  size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit"  class="el-icon-circle-plus-outline ctl" @click="toAdd4" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit"  v-show="delIndex8==index" class="el-icon-delete ctl" @click="delList4(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>24</td>
                    <!-- <td>验收阶段</td> -->
                    <td>规划验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in accept.plan.list" :key="index" @click="showFile(item)">
                                <span v-if="item.time" style="margin-right:1vw;">日期：{{item.time}}</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="accept.plan.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="accept.plan.flag">无</el-checkbox>
                        <div v-if="!accept.plan.flag">
                            <div v-for="(item,index) in accept.plan.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex9='-1'" @mouseenter="delIndex9=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess5"
                                    :on-remove="handleDel5"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary"  v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i  v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd5" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i  v-if="edit" v-show="delIndex9==index" class="el-icon-delete ctl" @click="delList5(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>25</td>
                    <!-- <td>验收阶段</td> -->
                    <td>消防验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in accept.fireAcceptance.list" :key="index" @click="showFile(item)">
                                <span v-if="item.time" style="margin-right:1vw;">日期：{{item.time}}</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="accept.fireAcceptance.flag">无</el-checkbox>
                        <el-checkbox v-else disabled  v-model="accept.fireAcceptance.flag">无</el-checkbox>
                        <div v-if="!accept.fireAcceptance.flag">
                            <div v-for="(item,index) in accept.fireAcceptance.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex10='-1'" @mouseenter="delIndex10=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess"
                                    :on-remove="handleDel"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex10==index" class="el-icon-delete ctl" @click="delList(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>26</td>
                    <!-- <td>验收阶段</td> -->
                    <td>竣工验收时间及验收文件</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in accept.completed.list" :key="index" @click="showFile(item)">
                                <span v-if="item.time" style="margin-right:1vw;" >日期：{{item.time}}</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <div>
                            <div v-for="(item,index) in accept.completed.list" :key="index" style="display:flex;" @mouseleave="delIndex11='-1'" @mouseenter="delIndex11=index">
                                <el-date-picker
                                    v-if="edit"
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-date-picker
                                    v-else disabled
                                    v-model="item.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess6"
                                    :on-remove="handleDel6"
                                    :on-preview="showFile"
                                    style="margin-left:1vw;"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i  v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd6" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit"  v-show="delIndex11==index" class="el-icon-delete ctl" @click="delList6(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>27</td>
                    <td>分部工程验收大表</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p v-for="(item,index) in accept.subdivisionProject.list[0].files" :key="index" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <el-checkbox  v-if="edit" v-model="accept.subdivisionProject.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="accept.subdivisionProject.flag">无</el-checkbox>
                        <div v-if="!accept.subdivisionProject.flag">
                            <div v-for="(item,index) in accept.subdivisionProject.list" :key="index" style="display:flex;margin-top:2vh;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess7"
                                    :on-remove="handleDel7"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>28</td>
                    <td>竣工验收报告</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p v-for="(item,index) in accept.acceptanceReport.list[0].files" :key="index" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <div>
                            <div v-for="(item,index) in accept.acceptanceReport.list" :key="index" style="display:flex;margin-top:2vh;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess8"
                                    :on-remove="handleDel8"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>29</td>
                    <td>竣工备案表</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p v-for="(item,index) in accept.completionRecord.list[0].files" :key="index" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="accept.completionRecord.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="accept.completionRecord.flag">无</el-checkbox>
                        <div v-if="!accept.completionRecord.flag">
                            <div v-for="(item,index) in accept.completionRecord.list" :key="index" style="display:flex;margin-top:2vh;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess9"
                                    :on-remove="handleDel9"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button v-if="edit"  size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>30</td>
                    <!-- <td>验收阶段</td> -->
                    <td>竣工图</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p v-for="(item,index) in accept.completionMap.list[0].files" :key="index" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="accept.completionMap.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="accept.completionMap.flag">无</el-checkbox>
                        <div v-if="!accept.completionMap.flag">
                            <div v-for="(item,index) in accept.completionMap.list" :key="index" style="display:flex;margin-top:2vh;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess10"
                                    :on-remove="handleDel10"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>31</td>
                    <!-- <td>验收阶段</td> -->
                    <td>获奖情况</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <p v-for="(item,index) in accept.awardWinning.list[0].files" :key="index" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" @click="showFile(item)">
                                <img :src="getIcon(item.url)" style="width:5vh;height:5vh;" />
                                <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{item.name}}</span>
                            </p>
                        </div>
                        <!-- <el-checkbox v-if="edit" v-model="accept.awardWinning.flag">无</el-checkbox>
                        <el-checkbox v-else disabled v-model="accept.awardWinning.flag">无</el-checkbox>
                        <div v-if="!accept.awardWinning.flag">
                            <div v-for="(item,index) in accept.awardWinning.list" :key="index" style="display:flex;margin-top:2vh;">
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess11"
                                    :on-remove="handleDel11"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                            </div>
                        </div> -->
                    </td>
                </tr>
                <tr>
                    <td>32</td>
                    <!-- <td>验收阶段</td> -->
                    <td>其他</td>
                    <td style="text-align: left;">
                        <div style="width:100%;display:flex;flex-wrap:wrap;">
                            <div style="width:100%;display:flex;height:auto;align-items: center;align-content: center;" v-for="(item,index) in accept.otherFile.list" :key="index" >
                                <span v-if="item.val">内容：{{item.val}}</span>
                                <div>
                                    <p v-for="(val,i) in item.files" :key="i" style="width:18vw;display:flex;height:6vh;align-items: center;align-content: center;" @click="showFile(val)">
                                        <img :src="getIcon(val.url)" style="width:5vh;height:5vh;" />
                                        <span style="width:calc( 100% - 5vh );padding:0 1vh;text-align: left;">{{val.name}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <el-checkbox  v-if="edit" v-model="accept.otherFile.flag">无</el-checkbox>
                        <el-checkbox  v-else disabled v-model="accept.otherFile.flag">无</el-checkbox>
                        <div v-if="!accept.otherFile.flag">
                            <div v-for="(item,index) in accept.otherFile.list" :key="index" style="display:flex;margin-top:2vh;" @mouseleave="delIndex12='-1'" @mouseenter="delIndex12=index">
                                <el-input v-if="edit"  v-model="item.val" placeholder="" style="margin-right:1vw;"></el-input>
                                <el-input v-else disabled v-model="item.val" placeholder="" style="margin-right:1vw;"></el-input>
                                <el-upload
                                    class="upload-demo len100"
                                    :action="uploadUrl"
                                    :headers="uploadHead"
                                    :data="{type:232}"
                                    :objectBind='item.index'
                                    :on-success="handleSuccess12"
                                    :on-remove="handleDel12"
                                    :on-preview="showFile"
                                    :file-list="item.files">
                                    <el-button size="small" type="primary" v-if="edit">点击上传</el-button>
                                </el-upload>
                                <i v-if="edit" class="el-icon-circle-plus-outline ctl" @click="toAdd12" style="color:#296dd3;font-size:3vh;cursor: pointer;"></i>
                                <i v-if="edit" v-show="delIndex12==index" class="el-icon-delete ctl" @click="delList12(index)" style="color:red;font-size:3vh;cursor: pointer;"></i>
                            </div>
                        </div> -->
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- <div v-if="edit" style="width:100%;height:8vh;position: relative;position: relative;display: flex;justify-content: center;justify-items: center;align-content: center;align-items: center;">
            <el-button type="primary" @click="onFinalSubmit">保存</el-button>
            <el-button>返回</el-button>
        </div> -->
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
export default {
    data(){
        return{
            id:"",
            groupId:'',
            agreeName:'',
            status:'',
            uploadUrl:myHttp.uploadFile, //上传地址
            uploadHead:{
                accessToken: util.session.get('token')
            },
            form:{},
            final:{  //
                designUnit:'',//设计单位
                reconnaissanceUnit:'',//勘察单位
                auditorDeptName:'',//总包单位
                auditorHeadName:'',//总包单位负责人
                auditorHeadPhone:'',//总包单位负责人电话
                jlAuditorDeptName:'',
                jlAuditorHeadName:'',
                jlAuditorHeadPhone:'',
                jcAuditorDeptName:'',
                jcAuditorHeadName:'',
                jcAuditorHeadPhone:'',
                auditorFirstDeptName:'',//初审单位
                auditorFirstHeadName:'',//初审单位负责人
                auditorFirstHeadPhone:'',//初审单位负责人电话
                auditorLastDeptName:'',//终审单位
                auditorLastHeadName:'',// 终审单位负责人
                auditorLastHeadPhone:'',// 终审单位负责人电话

                deliver:{ //清表、拆迁（含拆除物清运）、净地交付情况
                    flag:false,
                    list:[
                        {index:1,start:'',startTime:'',files:[]},
                    ],
                },
                transfer:{  //土地
                    flag:false,
                    list:[
                        {index:1,start:'',startTime:'',files:[]},
                    ],
                },
                   buildPermit:{  //施工许可证
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                startDate:"",//开工时间
                startBook:{  //施工许可证
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                 operation:{   //运维
                  flag:false,
                    list:[
                        {index:1,startTime:'',files:[]},
                    ],
                 },
                 schedulePlan:{  //总计划进度
                   flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                   },
                 nodePlan:{ //关键节点计划
                     flag:false,
                     list:[
                        {index:1,start:'',startTime:'',files:[]},
                       ],
                   },
                 nextPlan:{  //本月进展及下月计划
                   flag:false,
                     list:[
                        {index:1,name:'',startTime:'',files:[]},
                       ],
                    // start:0,
                    // end:0
                },
                monthProgress:{//月进度
                     flag:false,
                     list:[
                        {index:1,startTime:'',files:[]},
                       ],
                },
                inspection:{
                     flag:false,
                     list:[
                        {index:1,files:[]},
                       ],
                },
                amountAppr:{  //经济签证金额及审批表
                     flag:false,
                     total:0,
                     list:[
                        {index:1,startTime:'',money:'',name:'',files:[]},
                       ],
                },
                contactLetter:{//合约方联系函件
                     flag:false,  
                     list:[
                        {index:1,files:[]},
                       ],
                },
                notice:{  //通知通报
                     flag:false,
                     list:[
                        {index:1,files:[]},
                       ],
                },
                punish:{ //违约金处理处罚单
                    flag:false,
                     total:'',
                     list:[
                        {index:1,startTime:'',money:'',files:[]},
                       ], 
                },
                wagePay:{  //农民工工资
                     flag:false,
                     total:'',
                     list:[
                        {index:1,startTime:'',money:'',files:[]},
                       ], 
                },
                mapReport:{ //房产测绘报告
                    flag:false,
                     list:[
                        {index:1,files:[]},
                       ],
                },
                finishDate:'',  //完工时间
                otherFile:{
                    flag:false,
                    list:[
                        {name:'',files:[],index:1,} //index 用于区分list
                    ],
                },
                remarks:{
                     flag:false,
                     name:""
                },
                price:''
            },
            delIndex:'-1',
            delIndex1:'-1',
            delIndex3:'-1',
            unitKind:'',
            edit:false,

            //验收阶段
            accept:{  //
                fireAcceptance:{ //消防验收时间及验收文件
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                compositeAcceptance:{ //综检时间及验收文件
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                rainWater:{  //雨污水接管验收时间及验收文件
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                civilDenfence:{  //人防验收时间及验收文件
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                environmntProtect:{  //环保验收时间及验收文件  
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                plan:{  //规划验收时间及验收文件
                    flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                completed:{  //竣工验收时间及验收文件  
                    // flag:false,
                    list:[
                        {index:1,time:'',files:[]},
                    ],
                },
                subdivisionProject:{  //分部工程验收大表
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                acceptanceReport:{  //竣工验收报告
                    // flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                completionRecord:{  //竣工备案表
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                completionMap:{  //竣工图
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                awardWinning:{  //获奖情况
                    flag:false,
                    list:[
                        {index:1,files:[]},
                    ],
                },
                otherFile:{  //其他
                    flag:false,
                    list:[
                        {index:1,val:'',files:[]},
                    ],
                },
            },
            delIndex4:'-1',
            delIndex5:'-1',
            delIndex6:'-1',
            delIndex7:'-1',
            delIndex8:'-1',
            delIndex9:'-1',
            delIndex10:'-1',
            delIndex11:'-1',
            delIndex12:'-1',
            status:'',
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        var params = this.$route.params
        this.id = params.id
        this.status = params.status
        this.getInfo()
        //this.getData()
        // this.edit = util.session.get('principalId')== util.session.get('user').id?true:false
    },
    methods:{
        //获取合同信息
        getInfo(){
            var that = this
            myHttp.getContractById({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proContract
                    that.agreeName = data.entProjectName
                    that.unitKind = data.unitKind
                    that.unitType = data.unitType
                    that.getData()
                }
            })
        },
        //获取阶段信息
        getData(){
            var that = this
            myHttp.getBuildingInfo({
                contractId:this.id
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data.sgProBuilding
                    if(data){
                        for(var item in that.final){
                            if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
                                var str = JSON.parse(data[item])
                                for(var k in that.final[item]){
                                    if(str[k]){
                                        if(k=='list' && str[k].length==0){
                                            
                                        }else{
                                            that.final[item][k] = str[k]
                                        }
                                    }
                                }
                            }else if(data[item]){
                                that.final[item] = data[item]
                            }
                        }
                        //验收
                        for(var item in that.accept){
                            if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
                                var str = JSON.parse(data[item])
                                for(var k in that.accept[item]){
                                    if(str[k]){
                                        if(k=='list' && str[k].length==0){
                                            
                                        }else{
                                            that.accept[item][k] = str[k]
                                        }
                                    }
                                }
                            }else if(data[item]){
                                that.accept[item] = data[item]
                            }
                        }
                    }
                }
            })
            // myHttp.getContractStageByProjectId({
            //     contractId:this.id,
            //     status:'2',
            // }).then(function(resp){
            //     if(resp.data.code=='200'){
            //         var data = resp.data.data.object
            //         if(data){
            //             for(var item in that.final){
            //                 if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
            //                     var str = JSON.parse(data[item])
            //                     for(var k in that.final[item]){
            //                         if(str[k]){
            //                             if(k=='list' && str[k].length==0){
                                            
            //                             }else{
            //                                 that.final[item][k] = str[k]
            //                             }
            //                         }
            //                     }
            //                 }else if(data[item]){
            //                     that.final[item] = data[item]
            //                 }
            //             }
            //             //验收
            //             for(var item in that.accept){
            //                 if(data[item] && (data[item].indexOf('{')>-1 || data[item].indexOf('[')>-1)){
            //                     var str = JSON.parse(data[item])
            //                     for(var k in that.accept[item]){
            //                         if(str[k]){
            //                             if(k=='list' && str[k].length==0){
                                            
            //                             }else{
            //                                 that.accept[item][k] = str[k]
            //                             }
            //                         }
            //                     }
            //                 }else if(data[item]){
            //                     that.accept[item] = data[item]
            //                 }
            //             }
            //         }
            //     }
            // })
        },
        //获取文件类型
        getIcon(url){
            var result = '';
            if(!url){
                result = ''
            }else{
                var list = url.split('.')
                var str = list[list.length-1]
                if(base.docType.indexOf(str)>=0){
                    result = require('../../../assets/image/office/word.png')
                }else if(base.imgType.indexOf(str)>=0){
                    result = require('../../../assets/image/office/photo.png')
                }else if(base.excelType.indexOf(str)>=0){
                    result = require('../../../assets/image/office/excel.png')
                }else if(base.pdfType.indexOf(str)>=0){
                    result = require('../../../assets/image/office/pdf.png')
                }else{
                    result = require('../../../assets/image/office/undefined.png')
                }
            }
            return result
        },
        
        //展示文件
        showFile(file){
            window.open(base.httpCtx+file.baseUrl)
        },
        

        


    }
}
</script>

<style scoped>
    .bid-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>
    @import '/layui/css/layui.css';
    .bid-box .upload-demo{
        width: 50%;
    }
    .bid-box .el-form-item__content{
        text-align: left;
    }
    .bid-box i.ctl{
        height:40px;
        line-height: 40px;
        margin-left: 0.5vw;
    }
    .bid-box .len100 .el-upload-list__item{
        width: 100%;
    }
    .bid-box .el-form-item__label{
        font-size: 14px;
        font-weight: bold;
        color: #000;
    }
    .bid-box .el-input__prefix{
        height: 40px;
    }
    /* .bid-box .el-upload-list__item-status-label{
        height: 40px;
        line-height: 40px;
    } */
    .layui-table td, .layui-table th{
        font-size: inherit;
    }
    .layui-table th{
        font-size: inherit;
        font-weight: bold;
        text-align: center;
    }

    .layui-table td, .layui-table th, .layui-table-col-set, .layui-table-fixed-r, .layui-table-grid-down, .layui-table-header, .layui-table-page, .layui-table-tips-main, .layui-table-tool, .layui-table-total, .layui-table-view, .layui-table[lay-skin=line], .layui-table[lay-skin=row]{
        border-color: #312e2e;
    }
</style>